// extracted by mini-css-extract-plugin
module.exports = {"city":"city-mM3nK","main_city":"main_city-ZF8ii"};